module.exports = __webpack_public_path__ + "static/media/Cairo-Medium.4592243c.ttf";